import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAccountSentimentReportPercentilesAverageRequestDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-percentiles-average.request.dto';
import { AccountSentimentReportPercentilesAverageAggregateRoot } from '../../../core/domain/aggregates/sentiment/account-sentiment-report-percentiles-average.aggregate-root';
import { GetAccountSentimentReportPercentilesAverageApplicationService } from '../../../core/application/services/sentiment/get-account-sentiment-report-percentiles-average.application-service';

export class GetAccountSentimentReportPercentilesAverageMetricsQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountSentimentReportPercentilesAverageApplicationService
  ) {}
  async execute(
    props: GetAccountSentimentReportPercentilesAverageRequestDto
  ): Promise<AccountSentimentReportPercentilesAverageAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
